export default "__VITE_ASSET__62d8795e__"